import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_ASSETINSPECTION,
  DELETE_ASSETINSPECTION,
  UPDATE_ASSETINSPECTION,
  ADD_NEW_ASSETINSPECTION,
} from "./actionType";

import {
  getAssetInspectionSuccess,
  getAssetInspectionFail,
  deleteAssetInspectionSuccess,
  deleteAssetInspectionFail,
  updateAssetInspectionSuccess,
  updateAssetInspectionFail,
  addAssetInspectionSuccess,
  addAssetInspectionFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAssetInspectionApi,
  getAssetInspectionApi,
  updateAssetInspectionApi,
  deleteAssetInspectionApi,
  addNewAssetInspectionApi
} from "../../helpers/backend_helper";

function* getAssetInspection({ payload: assetInspection }) {
  try {
    const response = yield call(getAssetInspectionApi, assetInspection);
    yield put(getAssetInspectionSuccess(GET_ASSETINSPECTION, response.data));
  } catch (error) {
    yield put(getAssetInspectionFail(GET_ASSETINSPECTION, error));
  }
}

function* onUpdateAssetInspection({ payload: assetInspection }) {
  try {
    if (assetInspection.setApprove) {
      const response = yield call(approveAssetInspectionApi, assetInspection);
      yield put(updateAssetInspectionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAssetInspectionApi, assetInspection);
      yield put(updateAssetInspectionSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAssetInspectionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAssetInspection({ payload: assetInspection }) {
  try {
    const response = yield call(deleteAssetInspectionApi, assetInspection);
    yield put(deleteAssetInspectionSuccess({ assetInspection, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAssetInspectionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAssetInspection({ payload: assetInspection }) {
  try {
    const response = yield call(addNewAssetInspectionApi, assetInspection);
    yield put(addAssetInspectionSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAssetInspectionFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAssetInspection() {
  yield takeEvery(GET_ASSETINSPECTION, getAssetInspection);
}

export function* watchUpdateAssetInspection() {
  yield takeEvery(UPDATE_ASSETINSPECTION, onUpdateAssetInspection);
}

export function* watchDeleteAssetInspection() {
  yield takeEvery(DELETE_ASSETINSPECTION, onDeleteAssetInspection);
}

export function* watchAddNewAssetInspection() {
  yield takeEvery(ADD_NEW_ASSETINSPECTION, onAddNewAssetInspection);
}

function* assetInspectionSaga() {
  yield all([
    fork(watchGetAssetInspection),
    fork(watchDeleteAssetInspection),
    fork(watchUpdateAssetInspection),
    fork(watchAddNewAssetInspection)
  ]);
}

export default assetInspectionSaga;
